//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['item', 'components'],
  methods: {
    add2basket(id) {
      let self = this;
      if(!!self.$parent.$data.PARAMS && self.$parent.$data.PARAMS.SHOW_ADDITIONAL_SOFTWARE_FORM == 'Y') {
        $.ajax({
          url: "/form/?form_id=catalog_additional_services&product=" + id + "&ajax=Y",
          type: "POST",
          success: function(response) {
            let $formWrapper = $('<div class="catalog-additional-services-form-wrapper"></div>');
            $formWrapper.html(response);
              window.scrollTo(0, 0);

              // $(document.body).find('*').hide();
            // $(document.body).append($formWrapper);

            $('header .breadcrumbs').hide();
            $('main.main').html($formWrapper.html());
          },
        });
      }
      else {
        $.ajax({
          url: "/local/ajax/basket.php",
          type: "POST",
          data: {'action': 'add', 'ID': id, 'MONTHS': 1},
          success: function(response) {
            AAM.TopBasket.refresh();
            AAM.showBasketSuccessPopup();
          },
        });
      }

    },
  },
  computed: {
    setLabel() {
      let self = this;
      let labelNames = {
        hit : 'Топ продаж',
        sale : 'Скидка',
        bitrix : 'Сервер для 1С'
      };
      let labelValue = self.item.PROPERTIES.LABEL.VALUE;
      for(let i in labelNames) {
          let labelName = labelNames[i]
          if(labelValue == i) {
            return {
              class : labelValue,
              name : labelName
            }
          }
      }
    },

    disksList() {
      let self = this;
      let result = [];

      for(let diskId in self.item.PROPERTIES.DISKS.VALUES_COUNT) {
          let currentCount = self.item.PROPERTIES.DISKS.VALUES_COUNT[diskId];

          result.push({
                'ID' : diskId,
                'NAME' : self.components.HDD[diskId].NAME,
                'COUNT' : currentCount,
              });
      }

      return result;
    },
  },
  mounted() {}
}



// WEBPACK FOOTER //
// ./depohost.ru/local/vue.js/v-dedicated-solution-item/v-dedicated-solution-item.vue